<td [colSpan]="columnsCount()">
  <div class="table__empty-message">Brak danych do wyświetlenia.</div>
</td>
